import { render, staticRenderFns } from "./twentyOneTable.vue?vue&type=template&id=7237f8e2&scoped=true"
import script from "./twentyOneTable.vue?vue&type=script&lang=ts"
export * from "./twentyOneTable.vue?vue&type=script&lang=ts"
import style0 from "./twentyOneTable.vue?vue&type=style&index=0&id=7237f8e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7237f8e2",
  null
  
)

export default component.exports